import React, { useState, forwardRef } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

// Wrap with React.forwardRef
export const PasswordField = forwardRef(({ field, label, error, helperText }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
     <TextField
        {...field}
        label={label}
        type={showPassword ? 'text' : 'password'}
        fullWidth
        margin="normal"
        variant="outlined" 
        error={!!error}
        helperText={helperText}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleToggleVisibility}
                  onMouseDown={(e) => e.preventDefault()} // Prevent focus loss on click
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
            autoComplete: 'new-password',
          },
      }}
    />
  );
});